(ns frontend.ui.component.badge.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [border-radius color]]))

(defn badge
  [{:keys [variant pill?]}]
  {:display          "inline-block"
   :margin           "4px 0"
   :padding          "4px 12px"
   :white-space      "nowrap"
   :background-color (theme/color [:badge variant :bg])
   :color            (theme/color [:badge variant :fg])
   :font-weight      "bold"
   :font-size        "12px"
   :border-radius    (if pill? "120px" (border-radius :xxxsmall))})
